module.exports = __webpack_public_path__ + "img/arrow-down-right-circle-fill.ddfe827f.svg";